<template>
  <div class="hello">
    <div class="helloTop">
      <div class="a926">
        <div class="a927">
          <div class="a928">敏捷处理、按需扩展、降低成本、数据安全</div>
          <div class="a929" v-for="(item, i) in itemdd" :key="i">
            <img src="../assets/shouye/3.png" alt="" />
            <div>{{ item.conment }}</div>
          </div>
          <div class="one_7">
            <div class="one_8" @click="isOpen = !isOpen">
              <div>立即获取</div>
              <img src="../assets//数字人/Union@2x.png" alt="" />
            </div>
            <el-link
              target="_blank"
              href="https://affim.baidu.com/unique_49847201/chat?siteId=19538945&userId=49847201&siteToken=d938ff4f7bae9254e1d97e1fae316cf6"
            >
              <!-- <div class="one_9">
                        <div>立即咨询</div>
                        <img src="../assets/HelloWorld/tubiao/67.png" alt="">
                    </div> -->
            </el-link>
          </div>
        </div>
      </div>
      <div class="a92">
        <div class="a927" style="margin: 0 0 0 500px">
          <div class="a928">敏捷处理、按需扩展、降低成本、数据安全</div>
          <div class="a929" v-for="(item, i) in itemd" :key="i">
            <img src="../assets/shouye/3.png" alt="" />
            <div>{{ item.conment }}</div>
          </div>
          <div class="one_7">
            <div class="one_8" @click="isOpen = !isOpen">
              <div>立即获取</div>
              <img src="../assets//数字人/Union@2x.png" alt="" />
            </div>
            <el-link
              target="_blank"
              href="https://affim.baidu.com/unique_49847201/chat?siteId=19538945&userId=49847201&siteToken=d938ff4f7bae9254e1d97e1fae316cf6"
            >
              <!-- <div class="one_9">
                <div>立即咨询</div>
                <img src="../assets/HelloWorld/tubiao/67.png" alt="" />
              </div> -->
            </el-link>
          </div>
        </div>
      </div>
      <!-- <div class="helloOne">
        <div class="helloTopOne">六年技术积累和服务升级，为企业保驾护航</div>
      </div>
      <div class="twoBoss">
        <div class="technology" v-for="(item, i) in items" :key="i">
          <img :src="item.img" alt="" />
          <div class="two_a">
            {{ item.title }}
          </div>
          <div class="two_b">
            {{ item.conment }}
          </div>
        </div>
      </div> -->
      <ChildComponent :is-open="isOpen" @update:isOpen="handleUpdate" />
    </div>
  </div>
</template>

<script>
import ChildComponent from '@/components/components/DialogComponent.vue'
export default {
  name: 'Safety',
  components: {
    ChildComponent,
  },
  data() {
    return {
      items: [
        {
          img: require('../assets/HelloWorld/huojian_s.png'),
          title: '更快速',
          conment:
            '岗位学习规划，任务推送， PC、APP、H5等多端口，充分优化学习路径',
        },
        {
          img: require('../assets/HelloWorld/dunpai_y.png'),
          title: '更稳定',
          conment: '支持百万级并发用户数， 保障网络信息和用户数据库安全',
        },
        {
          img: require('../assets/HelloWorld/shezhi_s.png'),
          title: '更智能',
          conment:
            '常规的学习管理，同步实现人员管理、 在岗管理、课程质量点评等',
        },
      ],
      isOpen: false,
      itemdd: [
        {
          conment:
            '岗位学习规划，任务推送，PC、APP、H5等多端口，充分优化学习路径',
        },
        {
          conment:
            ' 既能获取公有云服务更高的计算资源，又利用公有云的可扩展性，突破私有云的硬件限制 ',
        },
        {
          conment:
            '企业软件增加，内部技术压力骤增，大米智课+企业私有化模式，有效降低企业预算和运维成本 ',
        },
        {
          conment:
            '课件库、通讯录、组织架构私有化部署等，按需部署，满足企业数据部署需求',
        },
      ],
      itemd: [
        {
          conment:
            '岗位学习规划，任务推送，PC、APP、H5等多端口，充分优化学习路径',
        },
        { conment: '支持百万级并发用户数 ，保障网络信息和用户数据库安全' },
        {
          conment:
            '常规的学习管理，同步实现人员管理、 在岗管理、课程质量点评等',
        },
      ],
    }
  },
  methods: {
    handleUpdate(newVal) {
      this.isOpen = newVal // 接收到子组件传递的新的 isOpen 值，更新父组件的 isOpen 状态
    },
  },
  created() {
    window.addEventListener('scroll', function () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      // 滚动条滚动的距离
      if (scrollTop > 1250) {
        let doc = this.document.querySelectorAll('.technology')
        doc.forEach((item) => {
          item.classList.add('animate__animated')
          item.classList.add('animate__fadeInDown')
        })
      }
    })
  },
}
</script>

<style scoped lang="scss">
.a926 {
  background: url('../assets/shouye/1.png');
  background-size: 100% 100%;
  // height: 375px;
  margin: 80px 0 0;
}
.a927 {
  padding: 60px 80px;
}
.a928 {
  height: 24px;
  font-size: 24px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 24px;
  margin-bottom: 30px;
}
.a929 {
  display: flex;
  align-items: center;
  height: 34px;
  img {
    width: 17px;
    height: 17px;
    margin-right: 10px;
  }
  div {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}

.a92 {
  background: url('../assets/shouye/2.png');
  background-size: 100% 100%;
  // height: 375px;
  margin: 60px 0 80px;
}

.one_7 {
  margin-top: 24px;
  display: flex;
}
.one_8 {
  margin: 0 40px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #ffffff;
  width: 154px;
  height: 46px;
  background: linear-gradient(90deg, #eb6215 0%, #ebaf15 100%);
  cursor: pointer;
  img {
    height: 14px;
    margin: 0 0 0 6px;
  }
}
.one_9 {
  display: flex;
  width: 154px;

  color: #eb6415;
  font-size: 14px;
  height: 46px;
  border: 1px solid #eb6415;
  align-items: center;
  justify-content: center;
  img {
    margin: 2px 0 0;
    width: 22px;
  }
}

.animate__fadeInDown {
  -webkit-animation-name: none;
}
.technology:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.11);
  transform: translateY(-20px);
  /* cursor: pointer; */
  /* margin-top: -20px; */
  transition: all 0.3s ease;
}
.hello {
  // height: 540px;
  width: 1440px;
  .helloTop {
    padding: 0 120px;
    .helloOne {
      height: 90px;
      .helloTopOne {
        height: 56px;
        text-align: center;
        // padding: 80px 0 0;
        font-size: 40px;
        font-weight: 500;
        color: #121221;
      }
    }
    .twoBoss {
      display: flex;
      justify-content: space-between;
      height: 360px;
      margin: 32px 0 47px;
      width: 1200px;
      .technology {
        width: 320px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f7f8fc;
        img {
          height: 80px;
          padding: 65px 0 36px;
        }
        .two_a {
          height: 39px;
          line-height: 39px;
          font-size: 24px;
          color: #333333;
          font-weight: 500;
          margin-bottom: 24px;
        }
        .two_b {
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
          color: #929292;
          padding: 0 23px;
        }
      }
    }
  }
}
</style>
